/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Jr_2_WInputs */

const en_cp_jr_2_w = /** @type {(inputs: Cp_Jr_2_WInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`14 weeks · per team`)
};

const id_cp_jr_2_w = /** @type {(inputs: Cp_Jr_2_WInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`14 minggu · per tim`)
};

/**
* | output |
* | --- |
* | "14 weeks · per team" |
*
* @param {Cp_Jr_2_WInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_jr_2_w = /** @type {((inputs?: Cp_Jr_2_WInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Jr_2_WInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_jr_2_w(inputs)
	return en_cp_jr_2_w(inputs)
});